import { FileRoutesByPath } from "@tanstack/react-router";
import { createPaldockFileRoute, RouteType } from "utils/createPaldockFileRoute.ts";

export type {
    PaldockRoute as TenantRoute,
    RequiredStaticData,
    RouteStaticData,
    FlatRoute,
} from "utils/createPaldockFileRoute.ts";

export function createTenantFileRoute<TPath extends keyof FileRoutesByPath>(path: TPath) {
    return createPaldockFileRoute(path, RouteType.Tenant);
}
